// @flow
import React, { Component } from "react";
import classNames from "classnames";
import Grid from "@material-ui/core/Grid";
import Avatar from "@material-ui/core/Avatar";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Chip from "@material-ui/core/Chip";
import { withStyles } from "@material-ui/core/styles";

import type { DictionaryType } from "../../../global/types/GeneralTypes";
import type {
  PanelStylesClassesType,
  TableStylesClassesType
} from "../../../global/styles/generalStyles";
import type { PersonType } from "../../types/PersonTypes";
import {
  panelStyles,
  tableStyles,
  padImg,
  formRightBtnBlock
} from "../../../global/styles/generalStyles";
import PersonImage from "../../../../images/person_place.svg";
import { CancelButton, SubmitButton } from "imagus-components";

const styles = (theme: DictionaryType): DictionaryType => ({
  ...panelStyles(theme),
  ...tableStyles(theme),
  padImg,
  formRightBtnBlock,
  rightMargin: {
    marginRight: "5px"
  },
  tableBlock: {
    maxHeight: "360px",
    overflowY: "auto"
  }
});

type BulkTagFormStatesType = {
  loading: boolean,
  tags: Array<string>
};

type BulkTagFormClassesType = {
  ...PanelStylesClassesType,
  ...TableStylesClassesType,
  padImg: DictionaryType,
  formRightBtnBlock: DictionaryType,
  rightMargin: DictionaryType,
  tableBlock: DictionaryType
};

type BulkTagFormPropsType = {
  classes: BulkTagFormClassesType,
  checkedIds: Array<string>,
  people: Array<PersonType>,
  openSnackbar: Function,
  onClose: Function,
  tags: Array<DictionaryType>,
  getTags: Function,
  addTags: Function,
  ChipInput: React$ComponentType<*>
};

class BulkTagForm extends Component<
  BulkTagFormPropsType,
  BulkTagFormStatesType
> {
  constructor(props: BulkTagFormPropsType) {
    super(props);
    this.state = {
      loading: false,
      tags: []
    };
  }

  componentDidMount() {
    this.props.getTags();
  }

  syncChange = (name: string, value: *) => {
    this.setState({
      [name]: value
    });
  };

  submit = async (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();
    this.setState({ loading: true });

    const checkedPeople = this.props.people.filter(
      (x: PersonType): Function => this.props.checkedIds.indexOf(x.uid) > -1
    );
    checkedPeople.map((person: PersonType): * => {
      let newPerson = {};
      newPerson.uid = person.uid;
      newPerson.tags = this.state.tags;
      this.props.addTags(newPerson);
    });
    this.submitDone();
  };

  submitDone = (): * => {
    this.setState({ loading: false });
    this.props.openSnackbar(true, 3);
    this.props.onClose();
  };

  render(): React$Element<*> {
    const classes = this.props.classes;
    const loading = this.state.loading;

    const tagList =
      this.props.tags &&
      this.props.tags.sort().map((tag: string): DictionaryType => ({
        value: tag,
        label: tag
      }));

    const tags = this.state.tags.map((tag: string) => ({
      label: tag,
      value: tag
    }));

    const checkedPeople = this.props.people.filter(
      (x: PersonType): Function => this.props.checkedIds.indexOf(x.uid) > -1
    );

    const people = checkedPeople.map((person: PersonType, i: number): * => (
      <TableRow key={"person" + i}>
        <TableCell className={classNames(classes.border, classes.compact)}>
          {person.name}
        </TableCell>
        <TableCell className={classNames(classes.border, classes.compact)}>
          <Avatar
            alt={person.face}
            className={classes.padImg}
            src={person.face ? person.face : PersonImage}
          />
        </TableCell>
        <TableCell className={classNames(classes.border, classes.compact)}>
          {person.tags &&
            person.tags.map((tag: string, j: number): * => (
              <Chip
                key={"chip" + j}
                label={tag}
                className={classes.rightMargin}
              />
            ))}
        </TableCell>
      </TableRow>
    ));

    const ChipInput = this.props.ChipInput;

    return (
      <form
        onSubmit={(!loading && this.submit) || undefined}
        className={classes.appWrapper}
      >
        <div className={classes.appPanel}>
          <div className={classes.appPanelContent}>
            <Grid container spacing={8}>
              <Grid item xs={12}>
                <ChipInput
                  name="tags"
                  label="New Tags"
                  allowCreate
                  isStyled
                  isMultiple
                  placeholder="Add a Tag"
                  tags={tagList}
                  value={tags}
                  syncChange={this.syncChange}
                />
              </Grid>
              <Grid item xs={12} className={classes.tableBlock}>
                <Table className={classes.appTable}>
                  <TableHead>
                    <TableRow>
                      <TableCell className={classes.border} colSpan={3}>
                        Selected People
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{people}</TableBody>
                </Table>
              </Grid>
              <Grid item xs={12}>
                <div className={classes.formRightBtnBlock}>
                  <CancelButton onClick={this.props.onClose} />
                  <SubmitButton
                    loading={loading}
                    disabled={this.props.checkedIds.length === 0}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </div>
      </form>
    );
  }
}

export default withStyles(styles)(BulkTagForm);
